module.exports = __webpack_public_path__ + "static/media/downNew.0b103428.svg";